import { useState, useEffect } from 'react';
import BillTrackerForm from './components/BillTrackerForm';
import BillTracker from './BillTracker';
// import { Chrono } from 'react-chrono';
import { URL_APPEND } from '@general/constants'
import axios from 'axios';

const AddBillTracker = () => {
    const [chrono, setChrono] = useState();
    const [selBill, setSelBill] = useState({});
    const [performedAjax, setPerformedAjax] = useState(false);

    let trackerUrl = `${URL_APPEND}/api/tracker/create`;

    let submitForm = (e, formData) => {
        e.preventDefault();

        let token = document.head.querySelector('meta[name="csrf-token"]');
        if (token) axios.defaults.headers.common['X-CSRFToken'] = token.content;

        axios.post(trackerUrl, formData).then(res => {
            setPerformedAjax(true)
            setSelBill({ value: formData.bill })
        });

        // console.log(formData)
    }

    useEffect(() => {
        document.querySelector('.btmenu').hidden = true
    }, [])

    return (
        <div className='row'>
            <div className='col-md-6'>
                {/* formRef={formRef} */}
                <BillTrackerForm
                    submitForm={submitForm}
                    setSelBill={setSelBill}
                    setPerformedAjax={setPerformedAjax} />
            </div>
            <div className='col-md-6'>
                <BillTracker
                    selBill={selBill}
                    performedAjax={performedAjax}
                    setPerformedAjax={setPerformedAjax}
                    hideBillSelector={true}
                    chronoMode='v'
                    hideInitBills={true}
                    isadmin={true}
                />
            </div>
        </div>
    )
}

export default AddBillTracker;